export default __webpack_public_path__ + "static/933-877f817cdf0c8eeece73d5029b2eaf35.gif";